import CustomButton from 'components/CustomInput/Button';
import CustomTable from 'components/CustomTable';
import TextHeader from 'components/CustomText/TextHeader';
import useReviewerFeedback from 'hooks/review/useReviewerFeedback';
import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components/macro';

const SLayout = styled.div`
    padding: 15px;
`;

const ReviewerFeedback = (props) => {
    const { rows, columns } = useReviewerFeedback();
    const history = useHistory();

    return (
        <SLayout>
            <TextHeader>Reviewer Feedback</TextHeader>

            <div style={{ marginTop: 20 }}>
                <CustomTable rows={rows} columns={columns} />
            </div>

            <div style={{ marginTop: 20 }}>
                <CustomButton onClick={() => history.push('/review-arrangement/updateMeetingAttendance')}>
                    Consolidate
                </CustomButton>
            </div>
        </SLayout>
    );
};

export default ReviewerFeedback;
